<template>
	<div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isFullLoaded">
			<SpinnerIcon />
		</div>
		<div class="offer-form">
			<OfferBasicForm
				ref="basic-form"
				v-show="!isFullLoaded"
				:isWeb="isWeb"
				:newOffer="newOffer"
				@createOffer="createOffer"
				@updateOffer="updateOffer"
				@handleModal="handleModal"
			/>
			<OfferTeaserForm ref="teaser-form" :isWeb="isWeb" v-show="!isFullLoaded" />
			<OfferCharsForm ref="chars-form" v-show="!isFullLoaded" :isEditing="isEditing" />
			<OfferDocsForm ref="docs-form" :isWeb="isWeb" :isEditing="isEditing" v-show="!isFullLoaded" />
			<OfferInvestorsForm
				ref="investors-form"
				:isWeb="isWeb"
				:isEditing="isEditing"
				v-show="!isFullLoaded"
			/>
			<OfferPermissionsForm
				ref="permissions-form"
				:isWeb="isWeb"
				v-show="!isFullLoaded"
				@validateBasicFormFields="validateBasicFormFields"
				:isEditing="isEditing"
			/>
			<div class="rowTypeCheckbox blindMode" :isEditing="isEditing" v-show="!isFullLoaded">
				<div class="detail-form__docs-title">
					<h1 class="detail-form__docs-title--text mt-20 mb-5">Blind Mode</h1>
				</div>
				<div>
					<label class="checkbox-field mt-20 mb-20"
						>Ativar Blind Mode
						<input type="checkbox" v-model="offer.blindMode" />
						<span class="checkmark"></span>
					</label>
				</div>
			</div>
			<OfferActionsForm
				:newOffer="newOffer"
				:isEditing="isEditing"
				@handleDeleteModal="handleDeleteModal"
				@validatePermissionsFormFields="validatePermissionsFormFields"
				v-show="!isFullLoaded"
			/>
			<DeleteModal
				:title="'Excluir Oferta'"
				:subtitle="'Tem certeza que deseja excluir esta oferta?'"
				:loader="isFullLoaded"
				v-show="showDeleteModal"
				@handleDeleteModal="handleDeleteModal()"
				@confirmDelete="confirmDelete()"
			/>
			<AlertModal
				v-if="showEmailModal"
				:isWeb="isWeb"
				:offerStatusName="offerStatusName"
				@setSelectedUsers="setSelectedUsers"
				@handleAlertModal="toggleAlertModal"
				@confirmUpdate="updateOffer($event)"
			/>
			<Modal
				v-if="modalNotificationCreatedOffer.isOpen"
				:title="modalNotificationCreatedOffer.title"
				:description="modalNotificationCreatedOffer.description"
				:primaryLabel="modalNotificationCreatedOffer.primaryLabel"
				:primaryDisabled="modalNotificationCreatedOffer.primaryDisabled"
				:secondaryLabel="modalNotificationCreatedOffer.secondaryLabel"
				@secondaryClick="toggleModal"
				@primaryClick="submitForm"
			>
				<div class="modal-checkboxes">
					<h2 class="modal-checkboxes__title">Enviar notificação para:</h2>
					<Checkbox
						v-for="(option, index) of modalOptions"
						:key="index"
						:class="{ 'modal-checkboxes--hide': option.hide }"
						:label="option.label"
						:internalValue="index"
						:checked="option.checked"
						:isDisabled="option.disabled"
						@change="handleCheckbox"
					/>
				</div>
			</Modal>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_OFFER_BY_ID,
	CREATE_OFFER,
	UPDATE_OFFER,
	DELETE_OFFER,
	GET_ALL_EMAIL_USERS,
} from '@/store/modules/offerManagement/actions';
import { GET_INVESTOR_REQUEST } from '@/store/modules/filters/investor/actions';

import OfferBasicForm from '@/components/modules/Offer/OfferDetail/OfferBasicForm/OfferBasicForm.vue';
import OfferPermissionsForm from '@/components/modules/Offer/OfferDetail/OfferPermissionsForm/OfferPermissionsForm.vue';
import OfferTeaserForm from '@/components/modules/Offer/OfferDetail/OfferTeaserForm/OfferTeaserForm.vue';
import OfferCharsForm from '@/components/modules/Offer/OfferDetail/OfferCharsForm/OfferCharsForm.vue';
import OfferDocsForm from '@/components/modules/Offer/OfferDetail/OfferDocsForm/OfferDocsForm.vue';
import OfferInvestorsForm from '@/components/modules/Offer/OfferDetail/OfferInvestorsForm/OfferInvestorsForm.vue';
import OfferActionsForm from '@/components/modules/Offer/OfferDetail/OfferActionsForm/OfferActionsForm.vue';

import AlertModal from '@/components/modules/Offer/OfferDetail/AlertModal/AlertModal.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import Modal from '@/components/shared/Modal/Modal.vue';
import Checkbox from '@/components/shared/Checkbox/Checkbox.vue';
import { removeSpecialChars } from '@/utils/stringHelper';
import { copyAndRenameFile } from '@/utils/fileHelper';

export default {
	name: 'OfferForm',
	components: {
		AlertModal,
		DeleteModal,
		Modal,
		OfferBasicForm,
		OfferPermissionsForm,
		OfferTeaserForm,
		OfferCharsForm,
		OfferDocsForm,
		OfferInvestorsForm,
		OfferActionsForm,
		SpinnerIcon,
		Checkbox,
	},
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			blindMode: false,
		},
		userSendMailList: null,
		newOffer: false,
		isEditing: false,
		showDeleteModal: false,
		showEmailModal: false,
		offerStatusName: null,
		buttonPrimaryModalDisabled: true,
		isModalNotificationOpened: false,
		queryParams: {},
		modalOptions: [
			{
				label: 'Usuários específicos',
				checked: false,
				disabled: false,
				hide: false,
				disableOptions: [2],
				callback: 'notifySpecificUsers',
			},
			{
				label: 'Subscritos',
				checked: false,
				disabled: false,
				hide: false,
				disableOptions: [2],
				callback: 'notifySubscribedUsers',
			},
			{
				label: 'Não enviar',
				checked: false,
				disabled: false,
				hide: false,
				disableOptions: [0, 1],
				callback: 'dontNotifyUsers',
			},
		],
	}),
	mounted() {
		this.getInvestors({ vm: this }).then((res) => {
			if (this.$route.query.investor) {
				this.$refs.investor.setValue({
					id: this.user.investorId,
					name: this.user.investor,
				});
			}
		});

		this.getUserEmails({ vm: this });

		if (this.$route.query.id) {
			this.refreshOffer();
		} else {
			this.newOffer = true;
			this.modalOptions[2].hide = true;
		}
	},
	methods: {
		...mapActions('offerManagement', {
			getOffer: GET_OFFER_BY_ID,
			createOfferRequest: CREATE_OFFER,
			updateOfferRequest: UPDATE_OFFER,
			deleteOffer: DELETE_OFFER,
			getUserEmails: GET_ALL_EMAIL_USERS,
		}),
		...mapActions('investor', { getInvestors: GET_INVESTOR_REQUEST }),
		refreshOffer() {
			this.getOffer({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedOffer = res.data;

				this.offer.blindMode = selectedOffer.blindMode;

				//Carrega informações básicas do formulário
				this.$refs['basic-form'].loadOfferDetails(selectedOffer);

				//Carrega informações de permissões
				this.$refs['permissions-form'].loadOfferDetails(selectedOffer);

				//Carrega material publicitário e informações do vídeo
				this.$refs['teaser-form'].loadOfferDetails(selectedOffer);

				//componente de características
				if (selectedOffer.offerCharacteristics?.length) {
					this.$refs['chars-form'].loadOfferDetails(selectedOffer);
				}
				//componente de documentos
				if (selectedOffer.offerDocs?.length) {
					this.$refs['docs-form'].loadOfferDetails(selectedOffer);
				}
				//componente de investidores da oferta
				if (selectedOffer.offerInvestors?.length) {
					this.$refs['investors-form'].loadOfferDetails(selectedOffer);
				}
			});

			this.isEditing = true;
		},
		deepCopy(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		deletePropertyIfEqualTo(obj, property, value) {
			if (obj[property] == value) {
				delete obj[property];
			}
		},
		formatDate(obj, property, inputFormat, outputFormat) {
			obj[property] = this.$moment(obj[property], inputFormat).format(outputFormat);
		},
		replaceAndParseFloat(obj, property) {
			if (obj[property]) {
				obj[property] = parseFloat(obj[property].replace(',', '.'));
			}
		},
		processDocFiles(doc, index, isEditing, refs) {
			let docFile = refs['docs-form'].getDocFile(`docs_file_${doc.index || index + 1}`);
			if (docFile) {
				const sanitizedFileName = removeSpecialChars(docFile.name);
				docFile = copyAndRenameFile(docFile, sanitizedFileName);
				doc.docUrl = sanitizedFileName;
			}

			if (isEditing) {
				doc.docTypeId = doc.docType ? doc.docType.id : doc.docTypeId;
				doc.docSubtypeId = doc.docSubtype ? doc.docSubtype.id : doc.docSubtypeId;

				delete doc.createdAt;
				delete doc.deletedAt;
				delete doc.docSubtype;
				delete doc.docType;
			}
			delete doc.index;

			return {
				doc,
				docFile,
				shouldInclude:
					doc.name != null ||
					doc.docUrl != null ||
					doc.docTypeId != null ||
					doc.docSubtypeId != null,
			};
		},
		validateBasicFormFields() {
			this.$refs['basic-form'].validateFields();
		},
		validatePermissionsFormFields() {
			if (this.isEditing && !this.$route.query.action) {
				this.$refs['permissions-form'].validateFields();
			} else {
				this.validateBasicFormFields();
			}
		},
		async buildFormData() {
			const formData = new FormData();

			//pega os dados de cada formulário
			const basicFormData = this.$refs['basic-form'].getOfferData();
			const teaserFormData = this.$refs['teaser-form'].getTeaserData();
			const permissionsFormData = this.$refs['permissions-form'].getPermissionsData();
			const charsFormData = this.$refs['chars-form'].getCharsData();
			const docsFormData = this.$refs['docs-form'].getDocsData();
			const offerInvestorsData = this.$refs['investors-form'].getOfferInvestorsData();
			const blindModeFormData = {
				blindMode: this.offer.blindMode,
			};

			//fazemos um deepcopy dos dados para não alterar os valores na tela quando
			//formos enviar ao backend
			const deepCopyBasicForm = this.deepCopy(basicFormData);
			const deepCopyTeaserForm = this.deepCopy(teaserFormData);
			const deepCopyPermissionsForm = this.deepCopy(permissionsFormData);
			const deepCopyCharsForm = this.deepCopy(charsFormData);
			const deepCopyDocsForm = this.deepCopy(docsFormData);
			const deepCopyOfferInvestorsForm = this.deepCopy(offerInvestorsData);
			const deepCopyBlindModeForm = this.deepCopy(blindModeFormData);

			//mergea os dados dos forms em um único objeto
			let mergedForms = Object.assign(
				{},
				deepCopyBasicForm,
				deepCopyTeaserForm,
				deepCopyPermissionsForm,
				deepCopyCharsForm,
				deepCopyDocsForm,
				deepCopyOfferInvestorsForm,
				deepCopyBlindModeForm,
			);

			//Formata os dados necessários
			this.processMergedFormData(mergedForms);

			//Adiciona as características
			if (mergedForms.offerCharacteristics.length) {
				mergedForms.offerCharacteristics = mergedForms.offerCharacteristics.filter(
					(chars) => chars.label != null || chars.description != null,
				);

				mergedForms.offerCharacteristics.forEach((chars, index) => {
					chars.priority = index + 1;

					if (chars.id) delete chars.id;
					delete chars.index;
				});
			}

			//Adiciona os documentos
			if (mergedForms.offerDocs.length) {
				const processedDocs = mergedForms.offerDocs.map((doc, index) =>
					this.processDocFiles(doc, index, this.isEditing, this.$refs),
				);

				processedDocs.forEach(({ doc, docFile }) => {
					if (docFile != null) {
						formData.append('file', docFile);
					}
				});

				mergedForms.offerDocs = processedDocs
					.filter(({ shouldInclude }) => shouldInclude)
					.map(({ doc }) => doc);
			}

			//Adiciona os investidores da oferta
			if (mergedForms.offerInvestors.length) {
				mergedForms.offerInvestors = mergedForms.offerInvestors.filter(
					(investors) => investors.invested != 0 || investors.investor.id != null,
				);

				mergedForms.offerInvestors.forEach((investors, index) => {
					investors.priority = index + 1;

					if (investors.id) delete investors.index;
				});
			}

			//Busca o arquivo no TeaserForm
			if (mergedForms.teaserPdfUrl) {
				const teaserFile = this.$refs['teaser-form'].getTeaserFile();
				if (teaserFile != null) {
					const sanitizedFileName = removeSpecialChars(teaserFile.name);
					mergedForms.teaserPdfUrl = sanitizedFileName;
					formData.append('file', copyAndRenameFile(teaserFile, sanitizedFileName));
				}
			}

			formData.append('data', JSON.stringify(mergedForms));

			return formData;
		},
		processMergedFormData(mergedForms) {
			// Deletar as props totalValue e totalReserved se for igual a 0.00
			this.deletePropertyIfEqualTo(mergedForms, 'totalValue', '0.00');
			this.deletePropertyIfEqualTo(mergedForms, 'totalReserved', '0.00');
			this.deletePropertyIfEqualTo(mergedForms, 'offerInvestors.invested', '0.00');

			// Formatar as datas para enviar ao backend
			this.formatDate(mergedForms, 'saleOffEstimatedDate', 'DD/MM/YYYY', 'YYYY-MM-DD');
			this.formatDate(mergedForms, 'endOffEstimatedDate', 'DD/MM/YYYY', 'YYYY-MM-DD');

			// Fazer replace da vírgula por ponto para enviar ao backend
			this.replaceAndParseFloat(mergedForms, 'profitabilityMin');
			this.replaceAndParseFloat(mergedForms, 'profitabilityMax');

			mergedForms.totalValue = parseFloat(mergedForms.totalValue) || null;
			mergedForms.totalReserved = parseFloat(mergedForms.totalReserved) || null;
			mergedForms.demandValue = parseFloat(mergedForms.demandValue) || null;

			//Adiciona email list se necessário
			if (this.userSendMailList) {
				mergedForms['userSendMailList'] = this.userSendMailList;
			}

			//Adiciona os originadores das permissões
			if (mergedForms.originators.length) {
				mergedForms.originators = mergedForms.originators.map((item) => item.name);
			}

			//Adiciona os investidores das permissões
			if (mergedForms.investors.length) {
				mergedForms.investors = mergedForms.investors.map((item) => item.name);
			}

			//Adiciona a page das permissões
			if (mergedForms.dashboardType) {
				mergedForms.dashboardType = mergedForms.dashboardType.id;
			}

			//Adiciona o direcionamento das permissões
			if (mergedForms.initialPage) {
				mergedForms.initialPage = mergedForms.initialPage.id;
			}
		},
		async createOffer() {
			const formData = await this.buildFormData();

			this.createOfferRequest({
				vm: this,
				body: formData,
				params: this.queryParams,
			}).then((res) => {
				if (res.status == 201) {
					this.clearSendEmailParam();
					this.$router.push(
						this.$route.query.action
							? { path: '/dashboard/offer/detail', query: { id: res.data.id } }
							: { path: '/dashboard/offers' },
					);
				}
			});
		},
		async updateOffer() {
			const formData = await this.buildFormData();

			this.updateOfferRequest({
				vm: this,
				id: this.$route.query.id,
				body: formData,
				params: this.queryParams,
			}).then((res) => {
				if (res.status == 200) {
					this.clearSendEmailParam();
					this.refreshOffer();
				}
			});
		},
		handleModal(statusName) {
			this.offerStatusName = statusName;
			this.toggleModal();
		},
		toggleAlertModal() {
			this.showEmailModal = !this.showEmailModal;
		},
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteOffer({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/offers' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		async setSelectedUsers(param) {
			if (param) {
				this.userSendMailList = param.map((item) => item.id);
			}

			await this.callService();
		},
		async callService() {
			if (!this.newOffer && !this.$route.query.action) {
				await this.updateOffer();
			} else {
				await this.createOffer();
			}
		},
		toggleModal() {
			this.isModalNotificationOpened = !this.isModalNotificationOpened;
			this.clearModal(this.isModalNotificationOpened);
		},
		clearModal(isModalOpened) {
			if (isModalOpened) {
				this.queryParams = {};
				this.modalOptions = this.modalOptions.map((option) => {
					option.checked = false;
					option.disabled = false;
					return option;
				});
				this.userSendMailList = null;
			}
		},
		selectOption(index) {
			this.modalOptions[index].checked = !this.modalOptions[index].checked;
			return this.modalOptions[index].checked;
		},
		disableOptions(options, isChecked) {
			options.forEach((option) => {
				this.modalOptions[option].checked = false;
				this.modalOptions[option].disabled = isChecked;
			});
		},
		handleCheckbox(index) {
			const options = this.modalOptions[index].disableOptions;
			const isChecked = this.selectOption(index);
			this.disableOptions(options, isChecked);
			this.handleDisabledButtonModal(this.modalOptions);
		},
		handleDisabledButtonModal(options) {
			const hasSelectedOption = options.some((option) => option.checked);
			this.buttonPrimaryModalDisabled = !hasSelectedOption;
		},
		async dontNotifyUsers() {
			this.toggleModal();
		},
		notifySpecificUsers() {
			this.toggleModal();
			this.toggleAlertModal();
			this.setSendEmailParam();
		},
		notifySubscribedUsers() {
			this.queryParams['subscribedUsers'] = true;
			this.setSendEmailParam();
			if (!this.specificUsersSelected()) {
				this.toggleModal();
			}
		},
		setSendEmailParam() {
			if (!this.queryParams?.alertEmail) {
				this.queryParams['alertEmail'] = true;
			}
		},
		clearSendEmailParam() {
			if (this.queryParams.alertEmail) {
				this.queryParams = {};
			}
		},
		async submitForm() {
			for (const option of this.modalOptions) {
				const callback = option.callback;
				if (option.checked) {
					await this[callback]();
				}
			}

			if (!this.specificUsersSelected()) {
				await this.callService();
			}
		},
		specificUsersSelected() {
			return this.modalOptions[0].checked;
		},
	},
	computed: {
		...mapGetters('offerManagement', [
			'isLoadingOffers',
			'isLoadingOriginators',
			'isLoadingIndustries',
			'isLoadingOperation',
			'isLoadingStatus',
			'isLoadingIndexer',
			'isLoadingStructurer',
			'isLoadingDocType',
			'isLoadingDocSubtype',
		]),
		isFullLoaded() {
			return (
				this.isLoadingOffers ||
				(this.isLoadingOriginators &&
					this.isLoadingIndustries &&
					this.isLoadingOperation &&
					this.isLoadingStatus &&
					this.isLoadingIndexer &&
					this.isLoadingStructurer &&
					this.isLoadingDocType &&
					this.isLoadingDocSubtype)
			);
		},
		modalNotificationCreatedOffer() {
			return {
				title: `Oferta ${this.offerStatusName}`,
				isOpen: this.isModalNotificationOpened,
				description: `Ao criar uma oferta com o status ${this.offerStatusName} esta oferta ficará disponível na Plataforma. Você pode escolher quais usuários serão notificados. Antes de incluir uma oferta salve-a como Rascunho e certifique-se de que as informações estão completas.`,
				primaryLabel: 'Publicar',
				primaryDisabled: this.buttonPrimaryModalDisabled,
				secondaryLabel: 'Cancelar',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferForm.scss';
</style>
